export default "__VITE_ASSET__BacHrovQ__"